import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { getAbogados } from "../../redux/Sections/Abogados/actions";
import { mesasEntradaActions } from "../../redux/MesasEntrada/actions";

export const AbogadoModal = ({ show, handleClose, setAbogado, abogado, extrajudicial }) => {
  const { abogadosList } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    dispatch(getAbogados());
  }, []);

  useEffect(() => {
    if (abogadosList?.length) {
      setOptions(abogadosList.map((e) => {
        return {
          ...e,
          label: `${e.apellido} ${e.nombre}`,
          value: e.codexterno
        };
      }));
    }
  }, [abogadosList]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if(extrajudicial){
      dispatch(mesasEntradaActions.saveAbogadoExtrajudicial(abogado));
    }
    else{
      dispatch(mesasEntradaActions.saveAbogadoJudicial(abogado));
    }

    return handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" animation={false} centered>
      <Modal.Body className='my-3'>
        <Form onSubmit={handleSubmit}>
          <Form.Label className="mb-2">Seleccionar abogado</Form.Label>
          <ReactSelect
            options={options}
            onChange={(e) => {
              return setAbogado(e?.value);
            }}
          />
          <input
            className="input-required"
            onChange={() => ""}
            value={abogado ? abogado : ""}
            required
          />
          <div className="mt-3 text-center">
            <Button type="submit" className="mr-1">Aceptar</Button>
            <Button variant="danger" className="ml-1" onClick={() => location.replace("/home")}>Cancelar</Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};